import { compareAsc, compareDesc, parseISO } from "date-fns";

export function sortByDate(a:any, b:any, col:string, mode = 'asc') {
    const aTime = parseISO(a[col]);
    const bTime = parseISO(b[col]);

    if(mode === 'asc') {
        return compareAsc(aTime, bTime);
    }

    return compareDesc(aTime, bTime);
}
